<template>
  <div>
    <div
      class="white pt-4 pb-4 pl-4 pr-4 mb-5 rounded-lg"
    >
      <!-- Desktop -->
      <div class="d-none d-sm-flex justify-space-between align-center">
        <h1 class="primary--text font-weight-black">CLIENTES</h1>
        <div>
          <v-btn
            class="font-weight-regular mr-2"
            large
            depressed
            :outlined="!paidFilter"
            color="error"
            @click="$emit('changePaidFilter', !paidFilter)"
          >Pendientes de pago</v-btn>
          <v-btn
            class="font-weight-regular"
            large
            depressed
            color="primary"
            @click="$emit('changeComponent', 'ClientNew')"
          >NUEVO CLIENTE</v-btn>
        </div>
      </div>
      <!-- Mobile -->
      <div class="d-flex d-sm-none flex-column">
        <h1 class="primary--text font-weight-black mb-3">CLIENTES</h1>
        <div class="d-flex">
          <v-btn
            class="font-weight-regular flex-grow-1 mr-2"
            small
            depressed
            :outlined="!paidFilter"
            color="error"
            @click="$emit('changePaidFilter', !paidFilter)"
          >Pendientes</v-btn>
          <v-btn
            class="font-weight-regular flex-grow-1"
            small
            depressed
            color="primary"
            @click="$emit('changeComponent', 'ClientNew')"
          >NUEVO</v-btn>
        </div>
      </div>
    </div>

    <!-- Column headers - only on desktop -->
    <div
      class="white primary--text font-weight-black pt-4 pb-4 pl-4 pr-4 d-none d-md-flex align-center rounded-lg"
    >
      <div class="info--number">NO. CLIENTE</div>
      <div class="info-typeUser">TIPO</div>
      <div class="info--name">NOMBRE</div>
      <div class="info--phone">NO. TELEFONO</div>
      <div class="info--address">DIRECCION</div>
      <div class="info--actions text-center">ACCIONES</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClientsTableHead",
  props: {
    paidFilter: {
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
